<template>
  <v-container
    id="movimentacaoContas"
  >
    <div>
      <v-row v-if="loading">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            :style="styleObject"
            class="text-center"
          >
            <v-icon
              light
              class="custom-loader"
              :style="styleObject"
            >
              mdi-cached
            </v-icon>
            Carregando dados...
          </div>
        </v-col>
      </v-row>
      <v-row v-else-if="error">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            class="alert alert-danger"
          >
            {{ error }}
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-data-table
            id="headersMovimentacao"
            :headers="headers"
            :items="relatorioAnterior"
            :items-per-page="relatorioAnterior.length"
            hide-default-footer
            disable-sort
            class="elevation-1"
            style="color: black"
          >
            <template v-slot:[`item.data1`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data1 }}
              </td>
            </template>
            <template v-slot:[`item.data2`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data2 }}
              </td>
            </template>
            <template v-slot:[`item.data3`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data3 }}
              </td>
            </template>
            <template v-slot:[`item.data4`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data4 }}
              </td>
            </template>
            <template v-slot:[`item.data5`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data5 }}
              </td>
            </template>
            <template v-slot:[`item.data6`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.data6 }}
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowSaldoTotal',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      loading: false,
      error: null,
      select: [],
      headers: [],
      relatorioAnterior: [],
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showDadosRelatorioAnteiror()
      },

      async showDadosRelatorioAnteiror () {
        this.loading = true

        this.relatorioAnterior = []

        await FluxoCaixa.showRelatorioAnteiror(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.headers = resposta.data.headers

            this.relatorioAnterior = resposta.data.dadosMovimentacao.map((item) => {
              var listaMovimentacao = ({
                data1: parseFloat(item.data1).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data2: parseFloat(item.data2).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data3: parseFloat(item.data3).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data4: parseFloat(item.data4).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data5: parseFloat(item.data5).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                data6: parseFloat(item.data6).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaMovimentacao
            })
          } else if (resposta.data.text === 'Não há dados de saldo bancário') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há dados de contas a receber') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #movimentacaoContas {
    max-width: 100%
  }

  #formaterDados {
    font-size: 11px
  }
</style>
